import Vue from 'vue'
// Notification
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import { createModule } from 'vuexok'
import store from '@/store'
import { ApplicationCommentsListState, IApplicationCommentsListRequest, IApplicationComment } from './types'
import {
  fetchApplicationCommentsList,
  deleteApplicationComment,
  createApplicationComment,
  updateApplicationComment,
} from '@/api/applicationComments'

// eslint-disable-next-line import/prefer-default-export
export const appApplicationCommentsList = createModule(
  'appApplicationCommentsList',
  {
    namespaced: true,
    state: {
      isLoading: false,
      applicationId: null,
      searchQuery: '' as string | (string | null)[],
      newComment: '',
      editableComment: {
        id: '',
        data: '',
        application_id: '',
      },
      deletableComment: {
        id: '',
        data: '',
        application_id: '',
      },
      items: [],
    } as ApplicationCommentsListState,
    getters: {
      getApplicationID: state => state.applicationId,
      getSearchQuery: state => state.searchQuery,
      getItems: state => state.items,
      getIsLoading: state => state.isLoading,
      getNewComment: state => state.newComment,
      getEditableComment: state => state.editableComment,
      getDeletableComment: state => state.deletableComment,
    },
    mutations: {
      SET_APPLICATION_ID(state, val: string) {
        state.applicationId = val
      },
      SET_SEARCH_QUERY(state, val: string) {
        state.searchQuery = val
      },
      SET_ITEMS(state, val: any) {
        state.items = val
      },
      SET_IS_LOADING(state, val: boolean) {
        state.isLoading = val
      },
      SET_NEW_COMMENT(state, val: string) {
        state.newComment = val
      },
      SET_EDITABLE_COMMENT(state, val: IApplicationComment) {
        state.editableComment = val
      },
      SET_DELETABLE_COMMENT(state, val: IApplicationComment) {
        state.deletableComment = val
      },
    },
    actions: {
      async fetchApplicationCommentsList({ state }) {
        try {
          appApplicationCommentsList.mutations.SET_IS_LOADING(true)

          const queryParams: IApplicationCommentsListRequest = {}
          if (state.searchQuery) queryParams.data = state.searchQuery
          if (state.applicationId) queryParams.applicationId = state.applicationId

          const response:any = await fetchApplicationCommentsList(queryParams)

          appApplicationCommentsList.mutations.SET_ITEMS(response.data.data)

          return response.data.data
        } catch (error) {
          Vue.$toast({
            component: ToastificationContent,
            props: {
              title: "Error fetching comments' list",
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })

          return error
        } finally {
          appApplicationCommentsList.mutations.SET_IS_LOADING(false)
        }
      },
      async deleteApplicationComment({ state }) {
        try {
          appApplicationCommentsList.mutations.SET_IS_LOADING(true)

          const response = await deleteApplicationComment(state.deletableComment.id)
          Vue.$toast({
            component: ToastificationContent,
            props: {
              title: 'Success deleting comment',
              icon: 'Trash2Icon',
              variant: 'info',
            },
          })

          return response
        } catch (error) {
          Vue.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error deleting comment',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })

          return error.response
        } finally {
          appApplicationCommentsList.mutations.SET_IS_LOADING(false)
        }
      },
      async createApplicationComment({ state }) {
        try {
          appApplicationCommentsList.mutations.SET_IS_LOADING(true)

          const response = await createApplicationComment({
            application_id: state.applicationId,
            data: state.newComment,
          })

          Vue.$toast({
            component: ToastificationContent,
            props: {
              title: 'Success creating comment',
              icon: 'Trash2Icon',
              variant: 'info',
            },
          })

          return response
        } catch (error) {
          Vue.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error creating comment',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })

          return error.response
        } finally {
          appApplicationCommentsList.mutations.SET_IS_LOADING(false)
        }
      },
      async updateApplicationComment({ state }) {
        try {
          appApplicationCommentsList.mutations.SET_IS_LOADING(true)

          const response = await updateApplicationComment(state.editableComment)

          Vue.$toast({
            component: ToastificationContent,
            props: {
              title: 'Success updating comment',
              icon: 'Trash2Icon',
              variant: 'info',
            },
          })

          return response
        } catch (error) {
          Vue.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error updating comment',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })

          return error.response
        } finally {
          appApplicationCommentsList.mutations.SET_IS_LOADING(false)
        }
      },
    },
  },
)

appApplicationCommentsList.register(store)
